import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'userLogAction'

const addLogAction = (axios: IFactoryFunctionRequest<any, any>) => (actionId: number, moduleId: number, userId: string, userTargetId: string, location: string, _firmId: string, text: string): IFactoryResponse<any, any> => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data: {
      actionId,
      moduleId,
      userId,
      userTargetId,
      location,
      _firmId,
      text,
    },
  })
}

export default (axios: AxiosInstance) => ({
  addLogAction: addLogAction(useAxios(axios)),
})

// logUserAction: function(actionId, moduleId, userId, userTargetId, location, _firmId, text){
//   var actionLog = {
//       actionId: actionId,
//       userId: userId,
//       userTargetId: userTargetId,
//       location: location,
//       moduleId:moduleId,
//       _firmId: _firmId,
//       text:text
//   };
//   $http.post('/api/userLogAction', actionLog).then(function(response){
//       // Done
//   });
// }
